<div class="table-responsive table-wrapper">
  <table class="table table-striped table-borderless align-left" [ngClass]="isHoverable ? 'table-click' : ''">
    <thead class="thead-primary">
      <tr>
        <ng-container *ngFor="let item of dataFields">
          <th scope="col" class="sticky-top table-headers" [ngClass]="{'clickable': item.sortable, 'cursor-none': !item.sortable}" [ngStyle]="{ textAlign: item.align == 'CENTER' ? 'CENTER' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT' }" (click)="sortTable()">
            <div class="d-flex flex-row" [ngClass]="item.align == 'CENTER' ? 'justify-content-center' : item.align == 'RIGHT' ? 'justify-content-end' : 'justify-content-start'">
              <span class="my-auto">{{item?.label}}</span>
              <ng-container *ngIf="item.sortable">
                <img src="/assets/sorting_icon.svg" alt="sort-icon" class="my-auto">
              </ng-container>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="!isLoading && dataSource.length > 0;">
        <ng-container *ngFor="let row of dataSource; let i = index">
          <tr *ngIf="row.isFullRow" [ngClass]="row.isFullRow ? 'full-row' : ''">
            <td [attr.colspan]="5" [align]="'right'">
              {{ row.activity_hours }} {{ row.activity_amount }}
            </td>
          </tr>
          <tr *ngIf="!row.isFullRow">
            <ng-container *ngFor="let item of dataFields">

              <ng-container *ngIf="item.type == 'text' && item.field == 'srNo' ">
                <td [ngStyle]="{width: item.width ? item.width : '100px', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT' }">
                  {{(row[item.field] && row[item.field] !== ' ' ? row[item.field] : i+1)}}</td>
              </ng-container>

              <ng-container *ngIf="item.type == 'text' && item.field !== 'srNo' && item.disableLimitText">
                <td [ngStyle]="{width: item.width ? item.width : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT' }" [ngClass]="row[item.field] && row[item.field] !== ' ' ? '' : 'disable-text' ">
                  {{(row[item.field] && row[item.field] !== ' ' ? row[item.field] : "N/A")}}
                </td>
              </ng-container>
              <ng-container *ngIf="item.type == 'text' && item.field !== 'srNo' && !item.disableLimitText">
                <td [ngStyle]="{width: item.width ? item.width : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT' }" [ngClass]="row[item.field] && row[item.field] !== ' ' ? '' : 'disable-text' ">
                  {{(row[item.field] && row[item.field] !== ' ' ? row[item.field] : "N/A") | limitText}}
                </td>
              </ng-container>

              <ng-container *ngIf="item.type == 'link'">
                <td (click)="clickHandler(i)" class="link-td" [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}" [ngClass]="row[item.field] && row[item.field] !== ' ' ? '' : 'disable-text' ">{{(row[item.field] && row[item.field] !== ' ' ? row[item.field] : "N/A") | limitText}}</td>
              </ng-container>

              <ng-container *ngIf="item.type == 'html'">
                <td (click)="clickHandler(i)" class="html-td" [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}" [ngClass]="row[item.field] && row[item.field] !== ' ' ? '' : 'disable-text' " [innerHtml]="row[item.field] && row[item.field] !== ' ' ? row[item.field] : 'N/A'"></td>
              </ng-container>

              <ng-container *ngIf="item.type == 'dropaction'">
                <td [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}">
                  <intrasense-table-action-buttons [row]="row" [item]="item" [index]="i" (onBtnClick)="clickActionHandler($event)"></intrasense-table-action-buttons>
                </td>
              </ng-container>

              <ng-container *ngIf="item.type == 'viewaction'">
                <td [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}">
                  <intrasense-table-view-actions [row]="row" [item]="item" [index]="i"></intrasense-table-view-actions>
                </td>
              </ng-container>

              <ng-container *ngIf="item.type == 'action'">
                <td [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}">
                  <intrasense-table-actions [row]="row" [item]="item" [index]="i" (onBtnClick)="clickActionHandler($event)"></intrasense-table-actions>
                </td>
              </ng-container>

              <ng-container *ngIf="item.type == 'droptext'">
                <td [ngStyle]="{width: item.width ? item.width : item.field == 'srNo' ? '100px' : 'auto', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'RIGHT' : 'LEFT'}">
                  <intrasense-table-drop-text-actions [row]="row" [item]="item" [index]="i" (onBtnClick)="clickActionHandler($event)"></intrasense-table-drop-text-actions>
                </td>
              </ng-container>

              <ng-container *ngIf="item.type == 'toggle'">
                <td [ngStyle]="{width: item.width ? item.width : '100px', textAlign: item.align == 'CENTER' ? 'center' : item.align == 'RIGHT' ? 'right' : 'left'}">
                  <div class="form-check form-switch d-flex justify-content-center align-items-center m-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      style="width: 2.5em; height: 1.3em; cursor: pointer;"
                      [checked]="row[item.field] == (item.toggleActiveValue ?? '1')"
                      (change)="clickActionHandler({ index$: i, type$: 'toggle', actionEvent$: 'TOGGLE' })"
                    />
                  </div>
                </td>
              </ng-container>
            </ng-container>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
  <ng-container *ngIf="isLoading">
    <div class="text-center p-3">
        <intrasense-single-spinner [visible]="isLoading"></intrasense-single-spinner>
    </div>
  </ng-container>
  <ng-container *ngIf="!isLoading && dataSource.length <= 0">
    <div class="text-center p-3">
      <p>No Data Found...</p>
    </div>
  </ng-container>
</div>
<!--Pagination---->
<div *ngIf="totalRecords > itemsPerPage && enablePagination" class="pagination-container">
  <!-- Go to page input -->
  <div class="goto-page">
    <span>Go to page:</span>
    <input
    class="pagination-form-control"
      type="number"
      min="1"
      [max]="totalPages"
      [(ngModel)]="goToPageInput"
      (keyup.enter)="handleGoToPageInput()"
    />
    <button class="mat-flat-button btn-primary btn-small" (click)="handleGoToPageInput()">Go</button>
  </div>
  <!-- Pagination controls -->
  <div class="pagination-controls">
    <button (click)="goToFirst()" [disabled]="currentPage === 0" [matTooltip]="getFirstpageToolTip()" matTooltipPosition="above">First</button>
    <button (click)="goToPreviousGroup()" [disabled]="currentPageGroup === 0" [matTooltip]="getPreviousGroupTooltip()" matTooltipPosition="above">Previous</button>
    <button
      *ngFor="let page of pageButtons"
      (click)="goToPage(page)"
      [class.active]="isActive(page)">
      {{ page + 1 }}
    </button>
    <button (click)="goToNextGroup()" [disabled]="(currentPageGroup + 1) * 10 >= totalPages" [matTooltip]="getNextGroupTooltip()" matTooltipPosition="above">Next</button>
    <button (click)="goToLast()" [disabled]="currentPage === totalPages - 1" [matTooltip]="getLastpageToolTip()" matTooltipPosition="above">Last</button>
  </div>
</div>
